var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SeedTable',{ref:"drugTable",attrs:{"download":true,"remove":true,"filter":true,"height":"40vh","title":'Selected Validation Drugs ('+_vm.validationDrugCount+')',"nodeName":"drug"},on:{"remove":function($event){_vm.$emit('drugCountUpdate',_vm.updateCount())},"printNotificationEvent":_vm.printNotification}})
}
var staticRenderFns = []

export { render, staticRenderFns }